import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import ImportRivalsPreviewModal from './ImportRivalsPreviewModal';
import PromotionsModal from './PromotionsModal';
import { formatShieldUrl } from '../../common/models/Rival';
export default class RivalsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "rivals", []);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "filter", '');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    this.loadRivals();
  }
  loadRivals() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/rivals'
    }).then(response => {
      this.rivals = response.data || [];
      this.loading = false;
      m.redraw();
    }).catch(e => {
      console.error('Error loading rivals:', e);
      this.loading = false;
      this.rivals = [];
      m.redraw();
    });
  }
  deleteRival(id, name) {
    if (!confirm(app.translator.trans('bizkaitarra-lineup.forum.rivals.delete_confirm', {
      name
    }))) {
      return;
    }
    app.request({
      method: 'DELETE',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/rivals/".concat(id)
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('bizkaitarra-lineup.forum.rivals.delete_success'));
      this.rivals = this.rivals.filter(r => r.id !== String(id) && r.id !== id);
      m.redraw();
    }).catch(e => {
      console.error('Error deleting rival:', e);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.rivals.delete_error'));
    });
  }
  async exportRivalsJson() {
    this.loading = true;
    m.redraw();
    const exportData = [];
    for (const r of this.rivals) {
      var _r$attributes, _r$attributes2, _r$attributes3;
      const name = ((_r$attributes = r.attributes) == null ? void 0 : _r$attributes.name) || '';
      const escudo = ((_r$attributes2 = r.attributes) == null ? void 0 : _r$attributes2.escudo) || null;
      const division = ((_r$attributes3 = r.attributes) == null ? void 0 : _r$attributes3.division) || '1ª';
      let escudoBase64 = null;
      if (escudo) {
        const shieldUrl = formatShieldUrl(escudo);
        try {
          const response = await fetch(shieldUrl);
          if (response.ok) {
            const blob = await response.blob();
            escudoBase64 = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });
          }
        } catch (e) {
          console.error('Error fetching shield image for base64:', e);
        }
      }
      exportData.push({
        name,
        escudo,
        division,
        escudo_base64: escudoBase64
      });
    }
    const jsonString = JSON.stringify(exportData, null, 2);
    const blob = new Blob([jsonString], {
      type: 'application/json'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'rivales.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    this.loading = false;
    m.redraw();
  }
  triggerImportClick() {
    const input = document.getElementById('rivals-import-file-input');
    if (input) {
      input.click();
    }
  }
  importRivalsJson(e) {
    var _e$target$files;
    const file = (_e$target$files = e.target.files) == null ? void 0 : _e$target$files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = event => {
      try {
        const parsed = JSON.parse(event.target.result);
        if (!Array.isArray(parsed)) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('bizkaitarra-lineup.forum.rivals.import_invalid_file'));
          return;
        }
        const validRivals = parsed.filter(item => item && typeof item === 'object' && typeof item.name === 'string' && item.name.trim() !== '');
        if (validRivals.length === 0) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('bizkaitarra-lineup.forum.rivals.import_invalid_file'));
          return;
        }
        const existingNames = new Set(this.rivals.map(r => {
          var _r$attributes4;
          return (((_r$attributes4 = r.attributes) == null ? void 0 : _r$attributes4.name) || '').toLowerCase().trim();
        }));
        const rivalsToImport = validRivals.filter(r => !existingNames.has(r.name.toLowerCase().trim()));
        const rivalsSkipped = validRivals.filter(r => existingNames.has(r.name.toLowerCase().trim()));
        if (rivalsToImport.length === 0 && rivalsSkipped.length > 0) {
          app.alerts.show({
            type: 'warning'
          }, app.translator.trans('bizkaitarra-lineup.forum.rivals.import_no_new'));
          e.target.value = '';
          return;
        }
        app.modal.show(ImportRivalsPreviewModal, {
          rivalsToImport: rivalsToImport,
          rivalsSkipped: rivalsSkipped,
          onConfirm: async () => {
            this.loading = true;
            m.redraw();
            try {
              for (const item of rivalsToImport) {
                await app.request({
                  method: 'POST',
                  url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/rivals',
                  body: {
                    data: {
                      attributes: {
                        name: item.name.trim(),
                        escudo: item.escudo || null,
                        division: item.division || '1ª',
                        escudo_base64: item.escudo_base64 || null
                      }
                    }
                  }
                });
              }
              app.alerts.show({
                type: 'success'
              }, app.translator.trans('bizkaitarra-lineup.forum.rivals.import_success', {
                count: rivalsToImport.length
              }));
              this.loadRivals();
            } catch (err) {
              console.error('Error importing rivals sequentially:', err);
              app.alerts.show({
                type: 'error'
              }, app.translator.trans('bizkaitarra-lineup.forum.rivals.import_error'));
              this.loadRivals();
            }
          }
        });
      } catch (err) {
        console.error('Error parsing import file:', err);
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('bizkaitarra-lineup.forum.rivals.import_invalid_file'));
      }
      e.target.value = '';
    };
    reader.readAsText(file);
  }
  deleteAllRivals() {
    if (!confirm('¿Estás seguro de que deseas eliminar TODOS los rivales? Esta acción no se puede deshacer.')) {
      return;
    }
    this.loading = true;
    m.redraw();
    app.request({
      method: 'DELETE',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/rivals/all'
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, 'Todos los rivales han sido eliminados con éxito.');
      this.rivals = [];
      this.loading = false;
      m.redraw();
    }).catch(e => {
      console.error('Error deleting all rivals:', e);
      app.alerts.show({
        type: 'error'
      }, 'Error al eliminar todos los rivales.');
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    if (!this.canManage) return null;
    const filteredRivals = this.rivals.filter(r => {
      var _r$attributes5;
      const name = ((_r$attributes5 = r.attributes) == null ? void 0 : _r$attributes5.name) || '';
      return name.toLowerCase().includes(this.filter.toLowerCase());
    }).sort((a, b) => {
      var _a$attributes, _b$attributes;
      const nameA = ((_a$attributes = a.attributes) == null ? void 0 : _a$attributes.name) || '';
      const nameB = ((_b$attributes = b.attributes) == null ? void 0 : _b$attributes.name) || '';
      return nameA.localeCompare(nameB);
    });
    return m("div", {
      className: "RivalsPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.nav_back_taldezaina')), m(Link, {
      href: "/",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-home"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.nav_back_home'))), m("div", {
      className: "RivalsPage-header",
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; flex-wrap: wrap; gap: 20px;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.title')), m("div", {
      style: "display: flex; gap: 12px;"
    }, m(Button, {
      className: "Button Button--secondary",
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 8px 16px; border: 1px solid rgba(255,255,255,0.15);",
      onclick: this.exportRivalsJson.bind(this)
    }, m("i", {
      className: "fas fa-file-export"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_export')), app.session.user && app.session.user.isAdmin() && [m(Button, {
      className: "Button Button--secondary",
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 8px 16px; border: 1px solid rgba(255,255,255,0.15);",
      onclick: this.triggerImportClick.bind(this)
    }, m("i", {
      className: "fas fa-file-import"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_import')), m("input", {
      type: "file",
      id: "rivals-import-file-input",
      accept: ".json",
      style: "display: none;",
      onchange: this.importRivalsJson.bind(this)
    }), m(Button, {
      className: "Button Button--secondary",
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 8px 16px; border: 1px solid #a5d6a7; background: #e8f5e9; color: #2e7d32;",
      onclick: () => app.modal.show(PromotionsModal, {
        onSave: () => this.loadRivals()
      })
    }, m("i", {
      className: "fas fa-exchange-alt"
    }), "Promociones"), m(Button, {
      className: "Button Button--danger",
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 8px 16px;",
      onclick: this.deleteAllRivals.bind(this)
    }, m("i", {
      className: "fas fa-trash-alt"
    }), "Eliminar Todos")], m(Link, {
      href: app.route('bizkaitarra-lineup.rivals.escudos'),
      className: "Button Button--secondary",
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 8px 16px; border: 1px solid rgba(255,255,255,0.15);"
    }, m("i", {
      className: "fas fa-images"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_manage_shields')), m(Link, {
      href: app.route('bizkaitarra-lineup.rivals.create'),
      className: "Button Button--primary",
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 8px 16px;"
    }, m("i", {
      className: "fas fa-plus-circle"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_create')))), m("div", {
      className: "RivalsPage-filters",
      style: "margin-bottom: 35px; display: flex; gap: 15px; align-items: center;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 10px; flex: 1; max-width: 400px;"
    }, m("i", {
      className: "fas fa-search",
      style: "color: var(--muted-color);"
    }), m("input", {
      className: "FormControl",
      placeholder: String(app.translator.trans('bizkaitarra-lineup.forum.rivals.search_placeholder')),
      value: this.filter,
      oninput: e => this.filter = e.target.value,
      style: "flex: 1; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02);"
    }))), this.loading ? m(LoadingIndicator, null) : m("div", {
      className: "RivalsList-container",
      style: "background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px; padding: 20px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.15);"
    }, m("table", {
      className: "RivalsTable",
      style: "width: 100%; border-collapse: collapse;"
    }, m("thead", null, m("tr", {
      style: "border-bottom: 2px solid rgba(255,255,255,0.1); text-align: left;"
    }, m("th", {
      style: "padding: 15px 10px; width: 95px; color: var(--heading-color); font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.column_shield')), m("th", {
      style: "padding: 15px 10px; color: var(--heading-color); font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.column_name')), m("th", {
      style: "padding: 15px 10px; color: var(--heading-color); font-weight: bold; width: 180px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.column_created_at')), m("th", {
      style: "padding: 15px 10px; text-align: right; width: 220px; color: var(--heading-color); font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.column_actions')))), m("tbody", null, filteredRivals.map(r => {
      var _r$attributes6, _r$attributes7, _r$attributes8, _r$attributes9;
      const id = r.id;
      const name = ((_r$attributes6 = r.attributes) == null ? void 0 : _r$attributes6.name) || '';
      const escudo = (_r$attributes7 = r.attributes) == null ? void 0 : _r$attributes7.escudo;
      const createdAt = (_r$attributes8 = r.attributes) == null ? void 0 : _r$attributes8.createdAt;
      const formattedDate = createdAt ? new Date(createdAt).toLocaleDateString() : '-';
      const shieldUrl = formatShieldUrl(escudo);
      return m("tr", {
        className: "RivalItem",
        key: id,
        style: "border-bottom: 1px solid rgba(255,255,255,0.06); transition: background 0.2s ease;"
      }, m("td", {
        style: "padding: 15px 10px; vertical-align: middle; text-align: left;"
      }, shieldUrl ? m("img", {
        src: shieldUrl,
        alt: name,
        style: "height: 60px; width: 60px; object-fit: contain; border: 1px solid rgba(255, 255, 255, 0.1); padding: 4px; background: rgba(255,255,255,0.03); border-radius: 12px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);"
      }) : m("div", {
        style: "height: 60px; width: 60px; border-radius: 12px; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; border: 1px solid rgba(255, 255, 255, 0.1);"
      }, m("i", {
        className: "fas fa-shield-alt",
        style: "font-size: 2rem; color: var(--muted-color);"
      }))), m("td", {
        style: "padding: 15px 10px; vertical-align: middle;"
      }, m("span", {
        style: "font-size: 1.15em; font-weight: bold; color: var(--heading-color);"
      }, name), ((_r$attributes9 = r.attributes) == null ? void 0 : _r$attributes9.division) && m("span", {
        style: "font-size: 0.75em; padding: 2px 8px; border-radius: 6px; background: rgba(255,255,255,0.06); color: var(--muted-color); font-weight: bold; margin-left: 10px; border: 1px solid rgba(255,255,255,0.1); vertical-align: middle;"
      }, r.attributes.division)), m("td", {
        style: "padding: 15px 10px; vertical-align: middle; color: var(--muted-color);"
      }, formattedDate), m("td", {
        style: "padding: 15px 10px; vertical-align: middle; text-align: right;"
      }, m("div", {
        style: "display: flex; gap: 8px; justify-content: flex-end;"
      }, m(Link, {
        href: app.route('bizkaitarra-lineup.rivals.edit', {
          id: id
        }),
        className: "Button Button--secondary",
        style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 6px 12px; border: 1px solid rgba(255,255,255,0.15);",
        title: String(app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_edit'))
      }, m("i", {
        className: "fas fa-edit"
      }), app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_edit')), m(Button, {
        className: "Button Button--danger",
        style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; padding: 6px 12px;",
        onclick: this.deleteRival.bind(this, id, name)
      }, m("i", {
        className: "fas fa-trash"
      }), app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_delete')))));
    }))), filteredRivals.length === 0 && m("p", {
      style: "text-align: center; padding: 25px; color: var(--muted-color); font-style: italic; margin: 0;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.empty_list')))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/RivalsPage', RivalsPage);